import { h, Component, JSX } from 'preact';
import classNames from 'classnames';
import cssStyles from './index.css';
import { AppPreviewContent, EndScreen } from '../../lib/end-screen/end-screen';

interface VideoEndScreenAppPreviewProps {
  endScreen: EndScreen;
}

export default class VideoEndScreenAppPreview extends Component<
  VideoEndScreenAppPreviewProps
> {
  render(): JSX.Element {
    const { icon, name } =
      (this.props.endScreen.content as AppPreviewContent) || {};

    return (
      <div
        className={classNames(
          cssStyles.endScreen,
          cssStyles.endScreenAppPreview
        )}
        id="end_screen_app_preview"
      >
        <img src={icon} className={cssStyles.endScreenAppPreviewIcon} />
        <h1 className={cssStyles.endScreenAppPreviewName}>{name}</h1>
        <button className={cssStyles.endScreenAppPreviewCTA}>GET</button>
      </div>
    );
  }
}
